'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var uid = -1,
    events = {};

/**
 * Subscribes to an Event.
 *
 * @param {string} event - Name of the event.
 * @param {function} listener - Callback function.
 * @returns {number} Returns an id for this subscription.
 */
var on = function on(event, listener) {
    uid++;

    if (!events[event]) {
        events[event] = { queue: [] };
    }

    events[event].queue.push({
        uid: uid,
        listener: listener
    });

    return uid;
};

/**
 * Unsubscribes an Event.
 * If an event name is passed, all listeners to this event will be removed.
 *
 * @param {string|number} event - Can be id of subscription or event name.
 * @returns {string|number|boolean} Returns the removed id or event name.
 */
var off = function off(event) {
    if (typeof event === 'number') {
        for (var e in events) {
            if (events.hasOwnProperty(e)) {
                for (var i = events[e].queue.length; i--;) {
                    if (events[e].queue[i].uid === event) {
                        events[e].queue.splice(i, 1);

                        if (!events[e].queue.length) {
                            delete events[e];
                        }

                        return event;
                    }
                }
            }
        }
    }

    if (typeof event === 'string') {
        delete events[event];
        return event;
    }

    return false;
};

/**
 * Triggers all listeners of event.
 *
 * @param {string} event - Name of Event
 * @param {object} data - Data which will be passed to listeners. Can actually also be string, number or array. The listener should simply be able to handle the passed data.
 */
var trigger = function trigger(event) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!events[event] || !events[event].queue.length) {
        return;
    }

    // Cycle through topics queue, fire!
    events[event].queue.forEach(function (item) {
        item.listener(data);
    });
};

var _getEvents = function _getEvents() {
    return events;
};

exports.default = {
    on: on,
    off: off,
    trigger: trigger,
    _getEvents: _getEvents

    // window.pubsub = {
    //     _getEvents
    // }

};


//////////////////
// WEBPACK FOOTER
// ./client/pubsub.js
// module id = 125
// module chunks = 0